import React from "react";
import PropTypes from "prop-types";
import { MenuNavItem } from "./MenuNavItem";
import styles from "./MenuNav.module.scss";

const MenuNav = ({ isOpen, renderMenuLink, menuLinks, unmountTrap }) =>
	menuLinks?.map(group => (
		<ul key={group.id} className={styles.subMenuContainer}>
			{group.links?.map(menuLink => (
				<MenuNavItem
					key={menuLink?.displayTitle || menuLink?.linkText}
					renderMenuLink={renderMenuLink}
					isOpen={isOpen}
					menuLink={menuLink}
					unmountTrap={unmountTrap}
				/>
			))}
		</ul>
	));

MenuNav.propTypes = {
	isOpen: PropTypes.bool,
	renderMenuLink: PropTypes.func,
	menuLinks: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			links: PropTypes.arrayOf(
				PropTypes.shape({
					displayTitle: PropTypes.string,
					links: PropTypes.arrayOf(
						PropTypes.shape({
							id: PropTypes.string,
							linkText: PropTypes.string,
							url: PropTypes.string,
							target: PropTypes.string,
						})
					),
					id: PropTypes.string,
					linkText: PropTypes.string,
					url: PropTypes.string,
					target: PropTypes.string,
				})
			),
		})
	).isRequired,
	unmountTrap: PropTypes.func.isRequired,
};

MenuNav.defaultProps = {
	isOpen: false,
	renderMenuLink: (link, { classNames }) => (
		<a href={link.url} target={link.target} className={classNames?.link}>
			{link.linkText}
		</a>
	),
};

export default MenuNav;
export { MenuNav };
